import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin } from 'lucide-react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/" aria-label="Swanpoint homepage">Swanpoint</Link>
            <p>Transforming the way you invest with cutting-edge financial solutions and expert market insights.</p>
          </div>
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/about" aria-label="About page">About Us</Link></li>
              <li><Link to="/portfolio" aria-label="Portfolio page">Our Portfolio</Link></li>
              <li><Link to="/team" aria-label="Team page">Our Team</Link></li>
              <li><Link to="/contact" aria-label="Contact page">Contact Us</Link></li>
            </ul>
          </div>
          <div className="footer-links">
            <h3>Investor Resources</h3>
            <ul>
              <li><Link to="/faq" aria-label="Frequently asked questions">FAQs</Link></li>
              <li><Link to="/privacy" aria-label="Privacy Policy">Privacy Policy</Link></li>
              <li><Link to="/terms" aria-label="Terms of Service">Terms of Service</Link></li>
            </ul>
          </div>
          <div className="footer-social">
            <h3>Connect With Us</h3>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page"><Facebook size={20} /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Visit our Twitter page"><Twitter size={20} /></a>
              <a href="https://www.linkedin.com/company/swanppoint/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page"><Linkedin size={20} /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Swanpoint. All rights reserved.</p>
          <Link to="/contact" className="contact-button" aria-label="Contact Us page">Contact Us</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;